import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import AdvertisingTerms from "../legal/AdvertisingTerms";
import {ADVERTISING_TERMS_PATH} from "../sponsor/sponsorRoutes";

/**
 * Public, pre-rendered Advertising Terms page (kitecorp/transferify-ui#2602): the terms an advertiser
 * accepts on the booking form and contracts under when they pay after approval. Rendered like `/terms`
 * — in-flow SSG markup, so the document is crawlable, linkable and printable rather than hidden behind
 * a portal — and declared in every locale tree because the route mirrors must claim identical paths.
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.advertisingTerms.title}
				description={seo.advertisingTerms.description}
				path={ADVERTISING_TERMS_PATH}
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.advertisingTerms}</h1>
					<AdvertisingTerms/>
				</Prose>
			</ContentSurface>
		</>
	);
}
